export default "__VITE_ASSET__BAN4qd1X__"